import { render, staticRenderFns } from "./ProfilesWidgetPage.vue?vue&type=template&id=70fadfd6&scoped=true"
import script from "./ProfilesWidgetPage.vue?vue&type=script&lang=js"
export * from "./ProfilesWidgetPage.vue?vue&type=script&lang=js"
import style0 from "./ProfilesWidgetPage.vue?vue&type=style&index=0&id=70fadfd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fadfd6",
  null
  
)

export default component.exports